import { cilHome, cilUser, cilFile
    , cilSearch, cilLibrary, cilGraph, cilList} from '@coreui/icons'

export interface NavItem {
    name: string
    href: string
    icon?: any
    badge?: { color: string; text: string }
    roles?: string[] // Roles de Keycloak permitidos
    items?: NavItem[] // Para submenús caídos
}

export const navigationConfig: NavItem[] = [
    {
        name: 'Inicio',
        href: '/gestion',
        icon: cilHome,
    },
    {
        name: 'Documentos',
        href: '/gestion/documentos/',
        icon: cilFile,
    },
    {
        name: 'Colecciones',
        href: '/gestion/colecciones',
        icon: cilLibrary,
    },
    {
        name: 'Catálogos',
        href: '/gestion/catalogos',
        icon: cilList,
    },
    {
        name: 'Analítica',
        href: '/gestion/analitica',
        icon: cilGraph,
    },
    {
        name: 'Avisos',
        href: '/gestion/avisos',
        icon: cilGraph,
    }
]
